import { useState } from "react";
import * as S from "./style";
import { useRecoilValue } from "recoil";
import { PubMemberDto, getPubMemberList } from "../../../../api/member";
import { pubState } from "../../../../recoil/pub.atom";
import * as C from "../edit/style";

export interface MemberSearchProps {
  setSelectedUser: (v: { id: number; nickname: string } | null) => void;
  onClose: () => void;
}

const MemberSearch = ({ setSelectedUser, onClose }: MemberSearchProps) => {
  const pub = useRecoilValue(pubState);
  const [list, setList] = useState<PubMemberDto[]>([]);
  const [nickname, setNickname] = useState<string>("");

  // 멤버 선택
  const handleSelectMember = (member: PubMemberDto | null) => {
    if (!member) return;

    setSelectedUser({ id: member.userId, nickname: member.nickname });
    onClose();
  };

  // 닉네임 검색
  const handleSearchNickname = async () => {
    if (!pub) return;
    if (!nickname) {
      alert("닉네임을 입력해주세요. ");
      return;
    }
    try {
      const res = await getPubMemberList(nickname, pub.id);

      setList(res.memberList);
    } catch (error: any) {
      if (error.response && error.response.status === 404) {
        alert("검색한 닉네임을 찾을 수 없습니다.");
      } else {
        alert("에러가 발생했습니다. 다시 시도해주세요.");
      }
    }
  };

  return (
    <C.OwnerEditContainer>
      <C.OwnerEditPopup>
        <C.OwnerEditPopupHeader>
          <div>유저 검색</div>
          <img src="/image-web/icon/close.svg" alt="close" onClick={onClose} />
        </C.OwnerEditPopupHeader>
        <C.OwnerEditInputItem>
          <input
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="닉네임을 검색하세요. "
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearchNickname();
            }}
          />
        </C.OwnerEditInputItem>
        <S.MemberSearchListWrapper>
          <S.MemberSearchListHeader>
            <div className="name">이름(닉네임)</div>
            <div className="date">생년월일</div>
            <div className="phone">전화번호</div>
          </S.MemberSearchListHeader>
          <S.MemberSearchListBody>
            {list.map((item, index) => (
              <S.MemberSearchListItem
                key={index}
                onClick={() => handleSelectMember(item)}
              >
                <div className="name">
                  {item.name}({item.nickname})
                </div>
                <div className="date">{item.birthDay}</div>
                <div className="phone">{item.phoneNumber}</div>
              </S.MemberSearchListItem>
            ))}
          </S.MemberSearchListBody>
        </S.MemberSearchListWrapper>
      </C.OwnerEditPopup>
    </C.OwnerEditContainer>
  );
};

export default MemberSearch;
